import React from "react";

import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { Button } from "@/uiKit/atoms/Button.tsx";
import { CardContent } from "@/uiKit/atoms/CardContent.tsx";
import { CardFooter } from "@/uiKit/atoms/CardFooter.tsx";
import { CardHeader } from "@/uiKit/atoms/CardHeader.tsx";
import { Dialog } from "@/uiKit/atoms/Dialog.tsx";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

export type LGCImportInfoDialogProps = {
  open: boolean;
  onClose: () => void;
};

export const LGCImportInfoDialog: React.FC<LGCImportInfoDialogProps> = ({ open, onClose }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  return (
    <Dialog id="lgc-import-info-dialog" open={open} onClose={onClose} maxWidth="md">
      <CardHeader
        id="lgc-import-info-header"
        title={t("patientSync.lgc.connectionTitle")}
        onExit={onClose}
        variant="contained"
      />
      <CardContent>
        <Typography variant="body" className={styles.content}>
          {t("patientSync.lgc.connectionBody")}
        </Typography>
      </CardContent>
      <CardFooter position="end">
        <Button variant="outlined" data-action="sync.lgc.close" onClick={onClose}>
          {t("patientSync.lgc.close")}
        </Button>
      </CardFooter>
    </Dialog>
  );
};

const makeStyles = () => ({
  content: css({
    whiteSpace: "pre-line",
  }),
});
